<div matTooltip="Insurance: {{value1}}&#13;Tyres: {{value2}}&#13;Fuel Cons.: {{value3}}" [matTooltipClass]="'multi-line-tooltip'">
    <div *ngIf="exists >= 3" style="background-color: rgb(160, 64, 160); height: 8px; width: 12px">&nbsp;</div>
    <div *ngIf="exists < 3" style="background-color: rgb(223, 190, 223); height: 8px; width: 12px">&nbsp;</div>
    <div *ngIf="exists >= 2" style="background-color: rgb(160, 64, 160); height: 8px; width: 12px">&nbsp;</div>
    <div *ngIf="exists < 2" style="background-color: rgb(223, 190, 223); height: 8px; width: 12px">&nbsp;</div>
    <div *ngIf="exists >= 1" style="background-color: rgb(160, 64, 160); height: 8px; width: 12px">&nbsp;</div>
    <div *ngIf="exists < 1" style="background-color: rgb(223, 190, 223); height: 8px; width: 12px">&nbsp;</div>
</div>

